import React, { FC } from 'react';

import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";
import { Medium } from "@/constants/mediums";

const ElectricityReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.electricity} />;
};

export default ElectricityReadingsDetailPage;
